module.exports = __webpack_public_path__ + "static/img/manager-checking.01de1936.png";